// @flow
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Prompt } from 'react-router-dom';

import { colors } from '../../shared/styles';

import StyledForm from '../shared/StyledForm';
import Scrollable from '../shared/Scrollable';
import styled from 'styled-components';

import Button from '../shared/Button';
import RadioGroup from '../shared/forms/RadioGroup';
import ContactPicker from '../shared/forms/ContactPicker';

import Select from '../shared/forms/Select';

const StyledTable = styled.div`
    div.col div.half-width div {
        max-width: 50%;
    }
    color: ${colors.grey.default};
    padding: 10px 20px;

    & .row {
        max-width: 100%;
    }

    & table {
        width: 100%;
        max-width: 100%;
        border: solid 1px ${colors.offWhite};
        margin-bottom: 20px;
        border-collapse: collapse;
        border-spacing: 0;
        text-align: left;
    }

    & tbody,
    & tfoot,
    & thead,
    & tr,
    & th,
    & td {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        vertical-align: baseline;
        border-collapse: collapse;
        border-spacing: 0;
        vertical-align: middle;
        text-align: left;
    }

    thead {
        background: #e4e8e9;
        overflow: hidden;
        border-bottom: 1px solid #d9d9db;
    }

    th {
        box-sizing: border-box;
        width: calc((100% - 100px) / 3);
        font-weight: normal;
        padding: 15px 20px;

        &:last-of-type {
            width: 95px;
        }
    }

    tbody {
        tr {
            font-weight: lighter;
            background: #f3f3f5;

            &:nth-of-type(odd) {
                background: ${colors.white};
            }
        }
    }

    td {
        padding: 15px 20px;
        white-space: nowrap;
        vertical-align: middle;
    }
`;

export const validate = (values: Object) => {
    const errors = {};

    if (!Array.isArray(values.contacts) || values.contacts.length < 1) {
        errors.contacts = 'Please select at least one contact';
    }

    return errors;
};

let PropertyContactForm = props => {
    const {
        handleSubmit,
        dirty,
        submitting,
        contactList,
        reassignedContacts,
        contactRequestRegionOptions,
    } = props;
    return (
        <StyledForm onSubmit={handleSubmit}>
            <Prompt
                when={dirty && !submitting}
                message="You have made changes that will be lost if you proceed. Are you sure you want to continue?"
            />

            <Scrollable additionalClassName="scroll-area">
                <div className="noflex">
                    <div className="col">
                        <h4>Assigned Contacts</h4>

                        <Field
                            name="contacts"
                            component={ContactPicker}
                            contactList={contactList}
                            disabled={submitting}
                        />

                        <Field
                            name="showContactMoreInfo"
                            label="Show Contacts Email,Telephone on Property?"
                            component={RadioGroup}
                            disabled={submitting}
                            options={[
                                {
                                    text: 'Yes',
                                    value: 'yes',
                                },
                                {
                                    text: 'No',
                                    value: 'no',
                                },
                            ]}
                        />
                    </div>

                    <div className="col">
                        <h4>Reassigned Contacts</h4>

                        {!reassignedContacts ||
                            (reassignedContacts.length === 0 &&
                                <h4>None currently applied.</h4>)}

                        <StyledTable>
                            {reassignedContacts &&
                                reassignedContacts.length > 0 &&
                                <table className="contact-list">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Telephone</th>
                                            <th>Email</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reassignedContacts
                                            .filter(contact => contact != null)
                                            .map((contact, index) => {
                                                return (
                                                    <tr
                                                        key={`${index}.${contact.contactId !=
                                                        null
                                                            ? contact.contactId
                                                            : index}`}
                                                    >
                                                        <td>
                                                            {contact.contactForenames || ''}{' '}
                                                            {contact.contactSurname || ''}
                                                        </td>
                                                        <td>
                                                            {contact.contactTelephone ||
                                                                ''}
                                                        </td>
                                                        <td>
                                                            {contact.contactEmail
                                                                ? <a
                                                                      href={`mailto:${contact.contactEmail}`}
                                                                  >
                                                                      {
                                                                          contact.contactEmail
                                                                      }
                                                                  </a>
                                                                : ''}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>}
                        </StyledTable>
                    </div>

                    <div className="col">
                        <h4>Property Contact By Region</h4>

                        <Field
                            name="contactRequestByRegion"
                            label="Send contact request to Region Email?"
                            component={RadioGroup}
                            disabled={submitting}
                            options={[
                                {
                                    text: 'Yes',
                                    value: 'yes',
                                },
                                {
                                    text: 'No',
                                    value: 'no',
                                },
                            ]}
                        />
                        <div className="half-width">
                            <Field
                                name="contactRequestRegionId"
                                label="Property Contact Regions"
                                component={Select}
                                disabled={submitting}
                            >
                                <option value="">Select Region</option>

                                {contactRequestRegionOptions
                                    ? Object.keys(
                                          contactRequestRegionOptions
                                      ).map(contactRequestRegionId => {
                                          const contactRequestRegion =
                                              contactRequestRegionOptions[
                                                  contactRequestRegionId
                                              ];
                                          return (
                                              <option
                                                  key={
                                                      contactRequestRegion.contactRequestRegionId
                                                  }
                                                  value={
                                                      contactRequestRegion.contactRequestRegionId
                                                  }
                                              >
                                                  {
                                                      contactRequestRegion.contactRequestRegionName
                                                  }
                                              </option>
                                          );
                                      })
                                    : null}
                            </Field>
                        </div>
                    </div>
                </div>
            </Scrollable>

            <div className="sticky-footer">
                <Button type="submit" disabled={submitting}>
                    {submitting ? 'Saving...' : 'Save & Continue'}
                </Button>
            </div>
        </StyledForm>
    );
};

PropertyContactForm = reduxForm({
    form: 'propertyEditContacts',
    validate,
})(PropertyContactForm);

export default PropertyContactForm;



// WEBPACK FOOTER //
// ./src/components/PropertyForms/PropertyContactForm.js